import React from "react";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import { getDate } from "utils/formatDate";
import handleEscapeKey from "utils/handleEscapeKey";
import { pushNotification } from "utils/notifications";


class GhiChu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: props.showGhiChuChoVay || false, // Trạng thái popup
      dataPost: {
        Note: "",
      },
      dataSearch: {
        pageIndex: 1,
        pageSize: 10,
        choVayId: 0,
      },
      editItem: null,
    };
    this.toggleModal = this.props.onHide.bind(this);
    // Tạo instance của useEscapeKey và gán vào this.escListener
    this.escListener = handleEscapeKey(this.props.onHide);
  }
  componentDidMount() {
      // Thêm listener chỉ khi modal mở
  if (this.state.isModalOpen) this.escListener.addListener();
    let { data } = this.props;
    let { dataSearch } = this.state;
    dataSearch.choVayId = data.ChoVayId;
    dataSearch.pageIndex = 1;
    this.loadGhiChu(dataSearch);
  }

  componentWillUnmount() {
    // Gỡ listener khi component unmount
    this.escListener.removeListener();
  }
 
  toggleModal() {
    // Cập nhật trạng thái popup và thêm/xóa listener khi cần
    this.setState(
      (prevState) => ({ isModalOpen: !prevState.isModalOpen }),
      () => {
        if (this.state.isModalOpen) {
          this.escListener.addListener();
        } else {
          this.escListener.removeListener();
        }
      }
    );
  }

  componentDidUpdate() {
    //loadGhiChu;
    let { ghichuchovay, setLoadGhiChu, data } = this.props;
    let { loadGhiChu } = ghichuchovay;
    if (loadGhiChu) {
      setLoadGhiChu();
      let { dataSearch } = this.state;
      dataSearch.choVayId = data.ChoVayId;
      dataSearch.pageIndex = 1;
      this.loadGhiChu(dataSearch);
    }
  }
  loadGhiChu = (dataSearch) => {
    let { getListGhiChu } = this.props;
    this.setState({ dataSearch });
    getListGhiChu(dataSearch);
  };
  deleteItem = (data) => () => {
    let { deleteGhiChuChoVay } = this.props;
    deleteGhiChuChoVay({ choVayNoteId: data.ChovayNoteID });
  };
  setEditItem = (data) => () => {
    console.log(data, "hahahahah");
    this.setState({ editItem: { ...data } });
  };
  postGhiChu = () => () => {
    let { postGhiChuChoVay, data } = this.props;
    let { dataPost } = this.state;
    let { ChoVayId } = data;
    let { Note } = dataPost;
    if (!Note) {
      pushNotification("Hãy nhập ghi chú.", "error", "TOP_CENTER", 2000);
      return;
    }
    if (Note.length > 500) {
      pushNotification(
        "Ghi chú không được quá 500 ký tự.",
        "error",
        "TOP_CENTER",
        2000
      );
      return;
    }
    let dataSubmit = {
      ChoVayId: ChoVayId,
      Note: Note,
    };
    dataPost.Note = "";
    postGhiChuChoVay(dataSubmit);
    this.setState({ dataPost });
    if (typeof this.props.refress !== "undefined") {
      this.props.refress();
    }
  };
  postGhiChuEdit = () => () => {
    let { postGhiChuChoVay, data } = this.props;
    let { editItem } = this.state;
    let { ChoVayId } = data;
    let { Note } = editItem;
    if (!Note) {
      pushNotification("Hãy nhập ghi chú.", "error", "TOP_CENTER", 2000);
      return;
    }
    if (Note.length > 500) {
      pushNotification(
        "Ghi chú không được quá 500 ký tự.",
        "error",
        "TOP_CENTER",
        2000
      );
      return;
    }
    let dataSubmit = {
      ChoVayId: ChoVayId,
      Note: Note,
      ChovayNoteID: editItem.ChovayNoteID,
    };
    postGhiChuChoVay(dataSubmit);
    this.setState({ editItem: null });
  };
  onChangeNote = () => (evt) => {
    let { dataPost } = this.state;
    dataPost.Note = evt.target.value;
    this.setState({ dataPost });
  };
  onChangeNoteEdit = () => (evt) => {
    let { editItem } = this.state;
    editItem.Note = evt.target.value;
    this.setState({ editItem });
  };

  handlePageChange = (pageNumber) => {
    let { data } = this.props;
    let { dataSearch } = this.state;
    dataSearch.choVayId = data.ChoVayId;
    dataSearch.pageIndex = pageNumber;
    this.loadGhiChu(dataSearch);
  };

 onHide = () => {
   this.setState({ isModalOpen: false });
   this.props.onHide();
 };

  render() {
    let { chitiethopdong, onHide, ghichuchovay } = this.props;
    let { dataSearch, editItem, dataPost } = this.state;
    let { objListGhiChu } = chitiethopdong;
    let { showGhiChuChoVay } = ghichuchovay;
    let ListGhiChu = objListGhiChu.List;
    let TotalRowsGhiChu = objListGhiChu.TotalRows;
    var TotalQuantity = TotalRowsGhiChu;
    return (
      <Modal
        show={showGhiChuChoVay}
        onHide={this.onHide}
        size="modal-dialog modal-lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
            <img  src="/app-assets/images/logo-ghi-chu-v2.png"/>
            </span>
            Thêm ghi chú
          </h4>
          <button type="button" className="close-popup-new" onClick={onHide}>
          <img  src="/app-assets/images/icon-dong-popup-v2.png"/>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <form className="form tat-toan form-horizontal">
            <div className="form-body">
              <div className="form-body">
                <div className="form-group row">
                  <div className="col-md-12">
                    <textarea
                      rows="5"
                      className="input-sm  textarea-v2"
                      placeholder="Nhập nội dung"
                      onChange={this.onChangeNote()}
                      value={dataPost.Note}
                    ></textarea>
                  </div>
                </div>

                <div
                  id="headingCollapse6412"
                  className="mt-1"
                  href="#collapse6412"
                  aria-expanded="true"
                  aria-controls="collapse5412"
                >
                  <a
                    className="lead info collapsed"
                    href={() => false}
                  >
                    <h3 className="color-xanh-bold"> Lịch sử ghi chú</h3>
                  </a>
                </div>
                <div
                  id="collapse6412"
                  aria-labelledby="headingCollapse6412"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="table-responsive table-2 table-fixHeight">
                        <table className="table table-bordered mb-0 table-rounded">
                          <thead style={{height:"50px"}}>
                            <tr>
                              <th className="text-left color7-bold">Ghi chú</th>
                              <th className="color7-bold">Ngày ghi chú</th>
                              <th className="color7-bold">Người tạo</th>
                              <th className="w-25 color7-bold">Thao tác</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ListGhiChu.map((item) => {
                              return (
                                <tr className="note-morman">
                                  <td className="text-left">
                                    {(!editItem ||
                                      editItem.ChovayNoteID !==
                                        item.ChovayNoteID) &&
                                      item.Note}
                                    {editItem &&
                                      editItem.ChovayNoteID ===
                                        item.ChovayNoteID && (
                                        <input
                                          type="text"
                                          value={editItem.Note}
                                          autocomplete="off"
                                          onChange={this.onChangeNoteEdit()}
                                          className="form-control input-sm"
                                        ></input>
                                      )}
                                  </td>
                                  <td>{getDate(item.CreatedTime)}</td>
                                  <td>{item.CreatedBy}</td>
                                  <td className="text-center">
                                    {/* {!editItem && (
                                      <input
                                        type="button"
                                        value="Sửa"
                                        className="edit"
                                        onClick={this.setEditItem(item)}
                                      />
                                    )}
                                    {editItem && (
                                      <input
                                        type="button"
                                        id="save_button1"
                                        value="Lưu"
                                        className="save"
                                        onClick={this.postGhiChuEdit()}
                                      />
                                    )}

                                    {!editItem && (
                                      <input
                                        type="button"
                                        value="Xóa"
                                        className="delete"
                                        onClick={this.deleteItem(item)}
                                      />
                                    )} */}
                                    {(!editItem ||
                                      editItem.ChovayNoteID !==
                                        item.ChovayNoteID) && (
                                      // <input
                                      //   type="button"
                                      //   value="Sửa"
                                      //   className="edit"
                                      //   onClick={this.setEditItem(item)}
                                      // />
                                      <img
                                        src="/app-assets/images/icon-edit-v2.png" // Thay bằng đường dẫn ảnh sửa
                                        alt="Sửa"
                                        className="icon edit"
                                        onClick={this.setEditItem(item)}
                                        style={{ cursor: "pointer", width: "20px", marginRight: "5px" }}
                                      />
                                    )}
                                    &nbsp;
                                    {editItem &&
                                      editItem.ChovayNoteID ===
                                        item.ChovayNoteID && (
                                        // <input
                                        //   type="button"
                                        //   id="save_button1"
                                        //   value="Lưu"
                                        //   className="save"
                                        //   onClick={this.postGhiChuEdit()}
                                        // />
                                        <img
                                        src="/app-assets/images/icon-save-v2.png" // Thay bằng đường dẫn ảnh sửa
                                        alt="Lưu"
                                        id="save_button1"
                                        className="save"
                                        onClick={this.postGhiChuEdit()}
                                        style={{ cursor: "pointer", width: "20px", marginRight: "5px" }}
                                      />
                                      )}
                                      &nbsp;
                                    {(!editItem ||
                                      editItem.ChovayNoteID !==
                                        item.ChovayNoteID) && (
                                      // <input
                                      //   type="button"
                                      //   value="Xóa"
                                      //   className="delete"
                                      //   onClick={this.deleteItem(item)}
                                      // />
                                      <img
                                      src="/app-assets/images/icon-xoa-v2.png" // Thay bằng đường dẫn ảnh sửa
                                      alt="Xóa"
                                      className="delete"
                                      onClick={this.deleteItem(item)}
                                      style={{ cursor: "pointer", width: "20px", marginRight: "5px" }}
                                    />
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {TotalQuantity > 10 && (
                      <div className="footer-page-new">
                        <div className="col-xl-12 col-lg-12">
                          <div class="paniation-new d-flex justify-content-center">
                            <nav aria-label="Page navigation">
                              <Pagination
                                activePage={dataSearch.pageIndex}
                                itemsCountPerPage={dataSearch.pageSize}
                                totalItemsCount={TotalQuantity}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange}
                                itemClass="page-item"
                                linkClass="page-link"
                                activeClass="active"
                              />
                            </nav>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
        <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={onHide}
          > 
            <span>
              <i className="mdi mdi-close"></i>
            </span>
            &nbsp;  Đóng
          </button>
          <button
            type="button"
            className="btn btn-new-main button-popup-submit"
            onClick={this.postGhiChu()}
          >
            <span>
            <img  src="/app-assets/images/icon-add-v2.png"/>
            </span>
            &nbsp;  Thêm mới
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default GhiChu;
